(function () {

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $10ded7cf756b400f$var$elementMap = new Map();
var $10ded7cf756b400f$export$2e2bcd8739ae039 = {
    set (element, key, instance) {
        if (!$10ded7cf756b400f$var$elementMap.has(element)) $10ded7cf756b400f$var$elementMap.set(element, new Map());
        const instanceMap = $10ded7cf756b400f$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($10ded7cf756b400f$var$elementMap.has(element)) return $10ded7cf756b400f$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$10ded7cf756b400f$var$elementMap.has(element)) return;
        const instanceMap = $10ded7cf756b400f$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $10ded7cf756b400f$var$elementMap.delete(element);
    }
};


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $624ac0747f128bc7$var$MAX_UID = 1000000;
const $624ac0747f128bc7$var$MILLISECONDS_MULTIPLIER = 1000;
const $624ac0747f128bc7$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $624ac0747f128bc7$export$529769e360e2fa1b = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $624ac0747f128bc7$export$2fe53163c7bc4eaf = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $624ac0747f128bc7$export$6d2b3473b0986646 = (prefix)=>{
    do prefix += Math.floor(Math.random() * $624ac0747f128bc7$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $624ac0747f128bc7$export$530d045e570efb0f = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $624ac0747f128bc7$var$MILLISECONDS_MULTIPLIER;
};
const $624ac0747f128bc7$export$201d3c8336a47e6c = (element)=>{
    element.dispatchEvent(new Event($624ac0747f128bc7$var$TRANSITION_END));
};
const $624ac0747f128bc7$export$45a5e7f76e0caa8d = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $624ac0747f128bc7$export$d16800b7e59a8051 = (object)=>{
    // it's a jQuery object or a node element
    if ($624ac0747f128bc7$export$45a5e7f76e0caa8d(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($624ac0747f128bc7$export$529769e360e2fa1b(object));
    return null;
};
const $624ac0747f128bc7$export$795910f5f15a9633 = (element)=>{
    if (!$624ac0747f128bc7$export$45a5e7f76e0caa8d(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $624ac0747f128bc7$export$30e0dc115df457ed = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $624ac0747f128bc7$export$1a538cc28c24d2ec = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $624ac0747f128bc7$export$1a538cc28c24d2ec(element.parentNode);
};
const $624ac0747f128bc7$export$8793edee2d425525 = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $624ac0747f128bc7$export$b7a864e1eaef9de5 = (element)=>{
    element.offsetHeight // eslint-disable-line no-unused-expressions
    ;
};
const $624ac0747f128bc7$export$74ab881f7fc208ab = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $624ac0747f128bc7$var$DOMContentLoadedCallbacks = [];
const $624ac0747f128bc7$export$62028ff70825ead9 = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$624ac0747f128bc7$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $624ac0747f128bc7$var$DOMContentLoadedCallbacks)callback();
        });
        $624ac0747f128bc7$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $624ac0747f128bc7$export$702d680b21cbd764 = ()=>document.documentElement.dir === 'rtl';
const $624ac0747f128bc7$export$6be86de4be20ff32 = (plugin)=>{
    $624ac0747f128bc7$export$62028ff70825ead9(()=>{
        const $ = $624ac0747f128bc7$export$74ab881f7fc208ab();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $624ac0747f128bc7$export$51396ec711da548b = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $624ac0747f128bc7$export$d6cd5457cf4106ef = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $624ac0747f128bc7$export$51396ec711da548b(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $624ac0747f128bc7$export$530d045e570efb0f(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($624ac0747f128bc7$var$TRANSITION_END, handler);
        $624ac0747f128bc7$export$51396ec711da548b(callback);
    };
    transitionElement.addEventListener($624ac0747f128bc7$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $624ac0747f128bc7$export$201d3c8336a47e6c(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $624ac0747f128bc7$export$7bc25e2173fc3d1f = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};


/**
 * Constants
 */ const $1c297f733361d974$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $1c297f733361d974$var$stripNameRegex = /\..*/;
const $1c297f733361d974$var$stripUidRegex = /::\d+$/;
const $1c297f733361d974$var$eventRegistry = {} // Events storage
;
let $1c297f733361d974$var$uidEvent = 1;
const $1c297f733361d974$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $1c297f733361d974$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $1c297f733361d974$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$1c297f733361d974$var$uidEvent++}` || element.uidEvent || $1c297f733361d974$var$uidEvent++;
}
function $1c297f733361d974$var$getElementEvents(element) {
    const uid = $1c297f733361d974$var$makeEventUid(element);
    element.uidEvent = uid;
    $1c297f733361d974$var$eventRegistry[uid] = $1c297f733361d974$var$eventRegistry[uid] || {};
    return $1c297f733361d974$var$eventRegistry[uid];
}
function $1c297f733361d974$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $1c297f733361d974$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $1c297f733361d974$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $1c297f733361d974$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $1c297f733361d974$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $1c297f733361d974$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $1c297f733361d974$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $1c297f733361d974$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $1c297f733361d974$var$getTypeEvent(originalTypeEvent);
    if (!$1c297f733361d974$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $1c297f733361d974$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $1c297f733361d974$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $1c297f733361d974$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $1c297f733361d974$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $1c297f733361d974$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $1c297f733361d974$var$makeEventUid(callable, originalTypeEvent.replace($1c297f733361d974$var$namespaceRegex, ''));
    const fn = isDelegated ? $1c297f733361d974$var$bootstrapDelegationHandler(element, handler, callable) : $1c297f733361d974$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $1c297f733361d974$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $1c297f733361d974$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $1c297f733361d974$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $1c297f733361d974$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $1c297f733361d974$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($1c297f733361d974$var$stripNameRegex, '');
    return $1c297f733361d974$var$customEvents[event] || event;
}
const $1c297f733361d974$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $1c297f733361d974$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $1c297f733361d974$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $1c297f733361d974$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $1c297f733361d974$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $1c297f733361d974$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$1c297f733361d974$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($1c297f733361d974$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $1c297f733361d974$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = (0, $624ac0747f128bc7$export$74ab881f7fc208ab)();
        const typeEvent = $1c297f733361d974$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $1c297f733361d974$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $1c297f733361d974$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch  {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
var $1c297f733361d974$export$2e2bcd8739ae039 = $1c297f733361d974$var$EventHandler;


/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $61e4c97070b47d88$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch  {
        return value;
    }
}
function $61e4c97070b47d88$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $61e4c97070b47d88$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$61e4c97070b47d88$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$61e4c97070b47d88$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $61e4c97070b47d88$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $61e4c97070b47d88$var$normalizeData(element.getAttribute(`data-bs-${$61e4c97070b47d88$var$normalizeDataKey(key)}`));
    }
};
var $61e4c97070b47d88$export$2e2bcd8739ae039 = $61e4c97070b47d88$var$Manipulator;



/**
 * Class definition
 */ class $7beb0d0c06e1a235$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = (0, $624ac0747f128bc7$export$45a5e7f76e0caa8d)(element) ? (0, $61e4c97070b47d88$export$2e2bcd8739ae039).getDataAttribute(element, 'config') : {} // try to parse
        ;
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...(0, $624ac0747f128bc7$export$45a5e7f76e0caa8d)(element) ? (0, $61e4c97070b47d88$export$2e2bcd8739ae039).getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = (0, $624ac0747f128bc7$export$45a5e7f76e0caa8d)(value) ? 'element' : (0, $624ac0747f128bc7$export$2fe53163c7bc4eaf)(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
var $7beb0d0c06e1a235$export$2e2bcd8739ae039 = $7beb0d0c06e1a235$var$Config;



/**
 * Constants
 */ const $380170e9fa23ab96$var$VERSION = '5.3.8';
/**
 * Class definition
 */ class $380170e9fa23ab96$var$BaseComponent extends (0, $7beb0d0c06e1a235$export$2e2bcd8739ae039) {
    constructor(element, config){
        super();
        element = (0, $624ac0747f128bc7$export$d16800b7e59a8051)(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        (0, $10ded7cf756b400f$export$2e2bcd8739ae039).set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        (0, $10ded7cf756b400f$export$2e2bcd8739ae039).remove(this._element, this.constructor.DATA_KEY);
        (0, $1c297f733361d974$export$2e2bcd8739ae039).off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        (0, $624ac0747f128bc7$export$d6cd5457cf4106ef)(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return (0, $10ded7cf756b400f$export$2e2bcd8739ae039).get((0, $624ac0747f128bc7$export$d16800b7e59a8051)(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $380170e9fa23ab96$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
var $380170e9fa23ab96$export$2e2bcd8739ae039 = $380170e9fa23ab96$var$BaseComponent;




/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 
const $56a58c95834dffd7$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>(0, $624ac0747f128bc7$export$529769e360e2fa1b)(sel)).join(',') : null;
};
const $56a58c95834dffd7$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!(0, $624ac0747f128bc7$export$30e0dc115df457ed)(el) && (0, $624ac0747f128bc7$export$795910f5f15a9633)(el));
    },
    getSelectorFromElement (element) {
        const selector = $56a58c95834dffd7$var$getSelector(element);
        if (selector) return $56a58c95834dffd7$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $56a58c95834dffd7$var$getSelector(element);
        return selector ? $56a58c95834dffd7$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $56a58c95834dffd7$var$getSelector(element);
        return selector ? $56a58c95834dffd7$var$SelectorEngine.find(selector) : [];
    }
};
var $56a58c95834dffd7$export$2e2bcd8739ae039 = $56a58c95834dffd7$var$SelectorEngine;



/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 


/**
 * Constants
 */ const $0bc25ea29b774e6d$var$NAME = 'swipe';
const $0bc25ea29b774e6d$var$EVENT_KEY = '.bs.swipe';
const $0bc25ea29b774e6d$var$EVENT_TOUCHSTART = `touchstart${$0bc25ea29b774e6d$var$EVENT_KEY}`;
const $0bc25ea29b774e6d$var$EVENT_TOUCHMOVE = `touchmove${$0bc25ea29b774e6d$var$EVENT_KEY}`;
const $0bc25ea29b774e6d$var$EVENT_TOUCHEND = `touchend${$0bc25ea29b774e6d$var$EVENT_KEY}`;
const $0bc25ea29b774e6d$var$EVENT_POINTERDOWN = `pointerdown${$0bc25ea29b774e6d$var$EVENT_KEY}`;
const $0bc25ea29b774e6d$var$EVENT_POINTERUP = `pointerup${$0bc25ea29b774e6d$var$EVENT_KEY}`;
const $0bc25ea29b774e6d$var$POINTER_TYPE_TOUCH = 'touch';
const $0bc25ea29b774e6d$var$POINTER_TYPE_PEN = 'pen';
const $0bc25ea29b774e6d$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $0bc25ea29b774e6d$var$SWIPE_THRESHOLD = 40;
const $0bc25ea29b774e6d$var$Default = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $0bc25ea29b774e6d$var$DefaultType = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $0bc25ea29b774e6d$var$Swipe extends (0, $7beb0d0c06e1a235$export$2e2bcd8739ae039) {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$0bc25ea29b774e6d$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $0bc25ea29b774e6d$var$Default;
    }
    static get DefaultType() {
        return $0bc25ea29b774e6d$var$DefaultType;
    }
    static get NAME() {
        return $0bc25ea29b774e6d$var$NAME;
    }
    // Public
    dispose() {
        (0, $1c297f733361d974$export$2e2bcd8739ae039).off(this._element, $0bc25ea29b774e6d$var$EVENT_KEY);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        (0, $624ac0747f128bc7$export$51396ec711da548b)(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $0bc25ea29b774e6d$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        (0, $624ac0747f128bc7$export$51396ec711da548b)(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $0bc25ea29b774e6d$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $0bc25ea29b774e6d$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($0bc25ea29b774e6d$var$CLASS_NAME_POINTER_EVENT);
        } else {
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $0bc25ea29b774e6d$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $0bc25ea29b774e6d$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $0bc25ea29b774e6d$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $0bc25ea29b774e6d$var$POINTER_TYPE_PEN || event.pointerType === $0bc25ea29b774e6d$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
var $0bc25ea29b774e6d$export$2e2bcd8739ae039 = $0bc25ea29b774e6d$var$Swipe;


/**
 * Constants
 */ const $dbacec9b9313e733$var$NAME = 'carousel';
const $dbacec9b9313e733$var$DATA_KEY = 'bs.carousel';
const $dbacec9b9313e733$var$EVENT_KEY = `.${$dbacec9b9313e733$var$DATA_KEY}`;
const $dbacec9b9313e733$var$DATA_API_KEY = '.data-api';
const $dbacec9b9313e733$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $dbacec9b9313e733$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $dbacec9b9313e733$var$TOUCHEVENT_COMPAT_WAIT = 500 // Time for mouse compat events to fire after touch
;
const $dbacec9b9313e733$var$ORDER_NEXT = 'next';
const $dbacec9b9313e733$var$ORDER_PREV = 'prev';
const $dbacec9b9313e733$var$DIRECTION_LEFT = 'left';
const $dbacec9b9313e733$var$DIRECTION_RIGHT = 'right';
const $dbacec9b9313e733$var$EVENT_SLIDE = `slide${$dbacec9b9313e733$var$EVENT_KEY}`;
const $dbacec9b9313e733$var$EVENT_SLID = `slid${$dbacec9b9313e733$var$EVENT_KEY}`;
const $dbacec9b9313e733$var$EVENT_KEYDOWN = `keydown${$dbacec9b9313e733$var$EVENT_KEY}`;
const $dbacec9b9313e733$var$EVENT_MOUSEENTER = `mouseenter${$dbacec9b9313e733$var$EVENT_KEY}`;
const $dbacec9b9313e733$var$EVENT_MOUSELEAVE = `mouseleave${$dbacec9b9313e733$var$EVENT_KEY}`;
const $dbacec9b9313e733$var$EVENT_DRAG_START = `dragstart${$dbacec9b9313e733$var$EVENT_KEY}`;
const $dbacec9b9313e733$var$EVENT_LOAD_DATA_API = `load${$dbacec9b9313e733$var$EVENT_KEY}${$dbacec9b9313e733$var$DATA_API_KEY}`;
const $dbacec9b9313e733$var$EVENT_CLICK_DATA_API = `click${$dbacec9b9313e733$var$EVENT_KEY}${$dbacec9b9313e733$var$DATA_API_KEY}`;
const $dbacec9b9313e733$var$CLASS_NAME_CAROUSEL = 'carousel';
const $dbacec9b9313e733$var$CLASS_NAME_ACTIVE = 'active';
const $dbacec9b9313e733$var$CLASS_NAME_SLIDE = 'slide';
const $dbacec9b9313e733$var$CLASS_NAME_END = 'carousel-item-end';
const $dbacec9b9313e733$var$CLASS_NAME_START = 'carousel-item-start';
const $dbacec9b9313e733$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $dbacec9b9313e733$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $dbacec9b9313e733$var$SELECTOR_ACTIVE = '.active';
const $dbacec9b9313e733$var$SELECTOR_ITEM = '.carousel-item';
const $dbacec9b9313e733$var$SELECTOR_ACTIVE_ITEM = $dbacec9b9313e733$var$SELECTOR_ACTIVE + $dbacec9b9313e733$var$SELECTOR_ITEM;
const $dbacec9b9313e733$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $dbacec9b9313e733$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $dbacec9b9313e733$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $dbacec9b9313e733$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $dbacec9b9313e733$var$KEY_TO_DIRECTION = {
    [$dbacec9b9313e733$var$ARROW_LEFT_KEY]: $dbacec9b9313e733$var$DIRECTION_RIGHT,
    [$dbacec9b9313e733$var$ARROW_RIGHT_KEY]: $dbacec9b9313e733$var$DIRECTION_LEFT
};
const $dbacec9b9313e733$var$Default = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $dbacec9b9313e733$var$DefaultType = {
    interval: '(number|boolean)',
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $dbacec9b9313e733$var$Carousel extends (0, $380170e9fa23ab96$export$2e2bcd8739ae039) {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($dbacec9b9313e733$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $dbacec9b9313e733$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $dbacec9b9313e733$var$Default;
    }
    static get DefaultType() {
        return $dbacec9b9313e733$var$DefaultType;
    }
    static get NAME() {
        return $dbacec9b9313e733$var$NAME;
    }
    // Public
    next() {
        this._slide($dbacec9b9313e733$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && (0, $624ac0747f128bc7$export$795910f5f15a9633)(this._element)) this.next();
    }
    prev() {
        this._slide($dbacec9b9313e733$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) (0, $624ac0747f128bc7$export$201d3c8336a47e6c)(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            (0, $1c297f733361d974$export$2e2bcd8739ae039).one(this._element, $dbacec9b9313e733$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            (0, $1c297f733361d974$export$2e2bcd8739ae039).one(this._element, $dbacec9b9313e733$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $dbacec9b9313e733$var$ORDER_NEXT : $dbacec9b9313e733$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $dbacec9b9313e733$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $dbacec9b9313e733$var$EVENT_MOUSEENTER, ()=>this.pause());
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $dbacec9b9313e733$var$EVENT_MOUSELEAVE, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && (0, $0bc25ea29b774e6d$export$2e2bcd8739ae039).isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find($dbacec9b9313e733$var$SELECTOR_ITEM_IMG, this._element))(0, $1c297f733361d974$export$2e2bcd8739ae039).on(img, $dbacec9b9313e733$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $dbacec9b9313e733$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($dbacec9b9313e733$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($dbacec9b9313e733$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new (0, $0bc25ea29b774e6d$export$2e2bcd8739ae039)(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $dbacec9b9313e733$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($dbacec9b9313e733$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($dbacec9b9313e733$var$CLASS_NAME_ACTIVE);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($dbacec9b9313e733$var$CLASS_NAME_ACTIVE);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $dbacec9b9313e733$var$ORDER_NEXT;
        const nextElement = element || (0, $624ac0747f128bc7$export$7bc25e2173fc3d1f)(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($dbacec9b9313e733$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $dbacec9b9313e733$var$CLASS_NAME_START : $dbacec9b9313e733$var$CLASS_NAME_END;
        const orderClassName = isNext ? $dbacec9b9313e733$var$CLASS_NAME_NEXT : $dbacec9b9313e733$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        (0, $624ac0747f128bc7$export$b7a864e1eaef9de5)(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($dbacec9b9313e733$var$CLASS_NAME_ACTIVE);
            activeElement.classList.remove($dbacec9b9313e733$var$CLASS_NAME_ACTIVE, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($dbacec9b9313e733$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($dbacec9b9313e733$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($dbacec9b9313e733$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find($dbacec9b9313e733$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ((0, $624ac0747f128bc7$export$702d680b21cbd764)()) return direction === $dbacec9b9313e733$var$DIRECTION_LEFT ? $dbacec9b9313e733$var$ORDER_PREV : $dbacec9b9313e733$var$ORDER_NEXT;
        return direction === $dbacec9b9313e733$var$DIRECTION_LEFT ? $dbacec9b9313e733$var$ORDER_NEXT : $dbacec9b9313e733$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ((0, $624ac0747f128bc7$export$702d680b21cbd764)()) return order === $dbacec9b9313e733$var$ORDER_PREV ? $dbacec9b9313e733$var$DIRECTION_LEFT : $dbacec9b9313e733$var$DIRECTION_RIGHT;
        return order === $dbacec9b9313e733$var$ORDER_PREV ? $dbacec9b9313e733$var$DIRECTION_RIGHT : $dbacec9b9313e733$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $dbacec9b9313e733$var$Carousel.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ (0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $dbacec9b9313e733$var$EVENT_CLICK_DATA_API, $dbacec9b9313e733$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).getElementFromSelector(this);
    if (!target || !target.classList.contains($dbacec9b9313e733$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $dbacec9b9313e733$var$Carousel.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ((0, $61e4c97070b47d88$export$2e2bcd8739ae039).getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
(0, $1c297f733361d974$export$2e2bcd8739ae039).on(window, $dbacec9b9313e733$var$EVENT_LOAD_DATA_API, ()=>{
    const carousels = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find($dbacec9b9313e733$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$dbacec9b9313e733$var$Carousel.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ (0, $624ac0747f128bc7$export$6be86de4be20ff32)($dbacec9b9313e733$var$Carousel);
var $dbacec9b9313e733$export$2e2bcd8739ae039 = $dbacec9b9313e733$var$Carousel;


/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 



/**
 * Constants
 */ const $d66ebc93fbedd854$var$NAME = 'collapse';
const $d66ebc93fbedd854$var$DATA_KEY = 'bs.collapse';
const $d66ebc93fbedd854$var$EVENT_KEY = `.${$d66ebc93fbedd854$var$DATA_KEY}`;
const $d66ebc93fbedd854$var$DATA_API_KEY = '.data-api';
const $d66ebc93fbedd854$var$EVENT_SHOW = `show${$d66ebc93fbedd854$var$EVENT_KEY}`;
const $d66ebc93fbedd854$var$EVENT_SHOWN = `shown${$d66ebc93fbedd854$var$EVENT_KEY}`;
const $d66ebc93fbedd854$var$EVENT_HIDE = `hide${$d66ebc93fbedd854$var$EVENT_KEY}`;
const $d66ebc93fbedd854$var$EVENT_HIDDEN = `hidden${$d66ebc93fbedd854$var$EVENT_KEY}`;
const $d66ebc93fbedd854$var$EVENT_CLICK_DATA_API = `click${$d66ebc93fbedd854$var$EVENT_KEY}${$d66ebc93fbedd854$var$DATA_API_KEY}`;
const $d66ebc93fbedd854$var$CLASS_NAME_SHOW = 'show';
const $d66ebc93fbedd854$var$CLASS_NAME_COLLAPSE = 'collapse';
const $d66ebc93fbedd854$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $d66ebc93fbedd854$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $d66ebc93fbedd854$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$d66ebc93fbedd854$var$CLASS_NAME_COLLAPSE} .${$d66ebc93fbedd854$var$CLASS_NAME_COLLAPSE}`;
const $d66ebc93fbedd854$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $d66ebc93fbedd854$var$WIDTH = 'width';
const $d66ebc93fbedd854$var$HEIGHT = 'height';
const $d66ebc93fbedd854$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $d66ebc93fbedd854$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="collapse"]';
const $d66ebc93fbedd854$var$Default = {
    parent: null,
    toggle: true
};
const $d66ebc93fbedd854$var$DefaultType = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $d66ebc93fbedd854$var$Collapse extends (0, $380170e9fa23ab96$export$2e2bcd8739ae039) {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find($d66ebc93fbedd854$var$SELECTOR_DATA_TOGGLE);
        for (const elem of toggleList){
            const selector = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).getSelectorFromElement(elem);
            const filterElement = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $d66ebc93fbedd854$var$Default;
    }
    static get DefaultType() {
        return $d66ebc93fbedd854$var$DefaultType;
    }
    static get NAME() {
        return $d66ebc93fbedd854$var$NAME;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($d66ebc93fbedd854$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$d66ebc93fbedd854$var$Collapse.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $d66ebc93fbedd854$var$EVENT_SHOW);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSE, $d66ebc93fbedd854$var$CLASS_NAME_SHOW);
            this._element.style[dimension] = '';
            (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $d66ebc93fbedd854$var$EVENT_SHOWN);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $d66ebc93fbedd854$var$EVENT_HIDE);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        (0, $624ac0747f128bc7$export$b7a864e1eaef9de5)(this._element);
        this._element.classList.add($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSE, $d66ebc93fbedd854$var$CLASS_NAME_SHOW);
        for (const trigger of this._triggerArray){
            const element = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSE);
            (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $d66ebc93fbedd854$var$EVENT_HIDDEN);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($d66ebc93fbedd854$var$CLASS_NAME_SHOW);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle) // Coerce string values
        ;
        config.parent = (0, $624ac0747f128bc7$export$d16800b7e59a8051)(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($d66ebc93fbedd854$var$CLASS_NAME_HORIZONTAL) ? $d66ebc93fbedd854$var$WIDTH : $d66ebc93fbedd854$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($d66ebc93fbedd854$var$SELECTOR_DATA_TOGGLE);
        for (const element of children){
            const selected = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find($d66ebc93fbedd854$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $d66ebc93fbedd854$var$Collapse.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ (0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $d66ebc93fbedd854$var$EVENT_CLICK_DATA_API, $d66ebc93fbedd854$var$SELECTOR_DATA_TOGGLE, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of (0, $56a58c95834dffd7$export$2e2bcd8739ae039).getMultipleElementsFromSelector(this))$d66ebc93fbedd854$var$Collapse.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ (0, $624ac0747f128bc7$export$6be86de4be20ff32)($d66ebc93fbedd854$var$Collapse);
var $d66ebc93fbedd854$export$2e2bcd8739ae039 = $d66ebc93fbedd854$var$Collapse;


/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $1e278783c7067372$exports = {};

$parcel$export($1e278783c7067372$exports, "popperGenerator", function () { return $1839837374f95732$export$ed5e13716264f202; });
$parcel$export($1e278783c7067372$exports, "detectOverflow", function () { return $70321b611e132ecc$export$2e2bcd8739ae039; });
$parcel$export($1e278783c7067372$exports, "createPopperBase", function () { return $1839837374f95732$export$8f7491d57c8f97a9; });
$parcel$export($1e278783c7067372$exports, "createPopper", function () { return $98a9ef6d31ff03cd$export$8f7491d57c8f97a9; });
$parcel$export($1e278783c7067372$exports, "createPopperLite", function () { return $0468327f9101fb67$export$8f7491d57c8f97a9; });
var $935c50c8659545b7$exports = {};

$parcel$export($935c50c8659545b7$exports, "top", function () { return $935c50c8659545b7$export$1e95b668f3b82d; });
$parcel$export($935c50c8659545b7$exports, "bottom", function () { return $935c50c8659545b7$export$40e543e69a8b3fbb; });
$parcel$export($935c50c8659545b7$exports, "right", function () { return $935c50c8659545b7$export$79ffe56a765070d2; });
$parcel$export($935c50c8659545b7$exports, "left", function () { return $935c50c8659545b7$export$eabcd2c8791e7bf4; });
$parcel$export($935c50c8659545b7$exports, "auto", function () { return $935c50c8659545b7$export$dfb5619354ba860; });
$parcel$export($935c50c8659545b7$exports, "basePlacements", function () { return $935c50c8659545b7$export$aec2ce47c367b8c3; });
$parcel$export($935c50c8659545b7$exports, "start", function () { return $935c50c8659545b7$export$b3571188c770cc5a; });
$parcel$export($935c50c8659545b7$exports, "end", function () { return $935c50c8659545b7$export$bd5df0f255a350f8; });
$parcel$export($935c50c8659545b7$exports, "clippingParents", function () { return $935c50c8659545b7$export$390fd549c5303b4d; });
$parcel$export($935c50c8659545b7$exports, "viewport", function () { return $935c50c8659545b7$export$d7b7311ec04a3e8f; });
$parcel$export($935c50c8659545b7$exports, "popper", function () { return $935c50c8659545b7$export$ae5ab1c730825774; });
$parcel$export($935c50c8659545b7$exports, "reference", function () { return $935c50c8659545b7$export$ca50aac9f3ba507f; });
$parcel$export($935c50c8659545b7$exports, "variationPlacements", function () { return $935c50c8659545b7$export$368f9a87e87fa4e1; });
$parcel$export($935c50c8659545b7$exports, "placements", function () { return $935c50c8659545b7$export$803cd8101b6c182b; });
$parcel$export($935c50c8659545b7$exports, "beforeRead", function () { return $935c50c8659545b7$export$421679a7c3d56e; });
$parcel$export($935c50c8659545b7$exports, "read", function () { return $935c50c8659545b7$export$aafa59e2e03f2942; });
$parcel$export($935c50c8659545b7$exports, "afterRead", function () { return $935c50c8659545b7$export$6964f6c886723980; });
$parcel$export($935c50c8659545b7$exports, "beforeMain", function () { return $935c50c8659545b7$export$c65e99957a05207c; });
$parcel$export($935c50c8659545b7$exports, "main", function () { return $935c50c8659545b7$export$f22da7240b7add18; });
$parcel$export($935c50c8659545b7$exports, "afterMain", function () { return $935c50c8659545b7$export$bab79516f2d662fe; });
$parcel$export($935c50c8659545b7$exports, "beforeWrite", function () { return $935c50c8659545b7$export$8d4d2d70e7d46032; });
$parcel$export($935c50c8659545b7$exports, "write", function () { return $935c50c8659545b7$export$68d8715fc104d294; });
$parcel$export($935c50c8659545b7$exports, "afterWrite", function () { return $935c50c8659545b7$export$70a6e5159acce2e6; });
$parcel$export($935c50c8659545b7$exports, "modifierPhases", function () { return $935c50c8659545b7$export$d087d3878fdf71d5; });
var $935c50c8659545b7$export$1e95b668f3b82d = 'top';
var $935c50c8659545b7$export$40e543e69a8b3fbb = 'bottom';
var $935c50c8659545b7$export$79ffe56a765070d2 = 'right';
var $935c50c8659545b7$export$eabcd2c8791e7bf4 = 'left';
var $935c50c8659545b7$export$dfb5619354ba860 = 'auto';
var $935c50c8659545b7$export$aec2ce47c367b8c3 = [
    $935c50c8659545b7$export$1e95b668f3b82d,
    $935c50c8659545b7$export$40e543e69a8b3fbb,
    $935c50c8659545b7$export$79ffe56a765070d2,
    $935c50c8659545b7$export$eabcd2c8791e7bf4
];
var $935c50c8659545b7$export$b3571188c770cc5a = 'start';
var $935c50c8659545b7$export$bd5df0f255a350f8 = 'end';
var $935c50c8659545b7$export$390fd549c5303b4d = 'clippingParents';
var $935c50c8659545b7$export$d7b7311ec04a3e8f = 'viewport';
var $935c50c8659545b7$export$ae5ab1c730825774 = 'popper';
var $935c50c8659545b7$export$ca50aac9f3ba507f = 'reference';
var $935c50c8659545b7$export$368f9a87e87fa4e1 = /*#__PURE__*/ $935c50c8659545b7$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []);
var $935c50c8659545b7$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($935c50c8659545b7$export$aec2ce47c367b8c3, [
    $935c50c8659545b7$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $935c50c8659545b7$export$421679a7c3d56e = 'beforeRead';
var $935c50c8659545b7$export$aafa59e2e03f2942 = 'read';
var $935c50c8659545b7$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $935c50c8659545b7$export$c65e99957a05207c = 'beforeMain';
var $935c50c8659545b7$export$f22da7240b7add18 = 'main';
var $935c50c8659545b7$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $935c50c8659545b7$export$8d4d2d70e7d46032 = 'beforeWrite';
var $935c50c8659545b7$export$68d8715fc104d294 = 'write';
var $935c50c8659545b7$export$70a6e5159acce2e6 = 'afterWrite';
var $935c50c8659545b7$export$d087d3878fdf71d5 = [
    $935c50c8659545b7$export$421679a7c3d56e,
    $935c50c8659545b7$export$aafa59e2e03f2942,
    $935c50c8659545b7$export$6964f6c886723980,
    $935c50c8659545b7$export$c65e99957a05207c,
    $935c50c8659545b7$export$f22da7240b7add18,
    $935c50c8659545b7$export$bab79516f2d662fe,
    $935c50c8659545b7$export$8d4d2d70e7d46032,
    $935c50c8659545b7$export$68d8715fc104d294,
    $935c50c8659545b7$export$70a6e5159acce2e6
];


var $133f6f38ce92f501$exports = {};

$parcel$export($133f6f38ce92f501$exports, "applyStyles", function () { return $312913fa2edc14b2$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "arrow", function () { return $20e743289f291887$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "computeStyles", function () { return $063d2297888fea12$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "eventListeners", function () { return $fa02e10eb4995658$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "flip", function () { return $dabd09962ff7b702$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "hide", function () { return $7d3d400f3b7c97f3$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "offset", function () { return $8d644778f0e020f0$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "popperOffsets", function () { return $ee48a1861d343976$export$2e2bcd8739ae039; });
$parcel$export($133f6f38ce92f501$exports, "preventOverflow", function () { return $4804c92787f86449$export$2e2bcd8739ae039; });
function $13064aa41dd611dc$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $2835f189066da699$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $6be351e83d6bf643$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $6be351e83d6bf643$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $6be351e83d6bf643$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $312913fa2edc14b2$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $312913fa2edc14b2$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $312913fa2edc14b2$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $312913fa2edc14b2$var$applyStyles,
    effect: $312913fa2edc14b2$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $6653967f933aaf29$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $8d1d6c453d67c9ab$export$8960430cfd85939f = Math.max;
var $8d1d6c453d67c9ab$export$96ec731ed4dcb222 = Math.min;
var $8d1d6c453d67c9ab$export$2077e0241d6afd3c = Math.round;



function $9641053f99441231$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b49248e188a52b8b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
}


function $1b9ce20ada6267ed$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? (0, $2835f189066da699$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b49248e188a52b8b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $ad01075005a54bff$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $122a9b90bb37fc73$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $6be351e83d6bf643$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $270edfbc2bfbd22f$export$2e2bcd8739ae039(element) {
    return (0, $2835f189066da699$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $27c48183f07ddbe8$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) >= 0;
}




function $37f38c85c1edad4d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $c16bae6800ecc025$export$2e2bcd8739ae039(element) {
    if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $3df2d470c30a409e$var$getTrueOffsetParent(element) {
    if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3df2d470c30a409e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    if (isIE && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element);
    if ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3df2d470c30a409e$export$2e2bcd8739ae039(element) {
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $27c48183f07ddbe8$export$2e2bcd8739ae039)(offsetParent) && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $3df2d470c30a409e$var$getContainingBlock(element) || window;
}


function $271a905a3adf884c$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max) {
    return (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(min, (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(value, max));
}
function $4faf3481d1df2f95$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $5dd4eac14cb3a9cb$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $0ad6ec2b432662d8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)(), paddingObject);
}


function $e3a5d8ce75f76756$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $20e743289f291887$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
};
function $20e743289f291887$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $20e743289f291887$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $20e743289f291887$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $20e743289f291887$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $20e743289f291887$var$arrow,
    effect: $20e743289f291887$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $66a6b9b7896d6ec4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $063d2297888fea12$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $063d2297888fea12$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $063d2297888fea12$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var sideY = (0, $935c50c8659545b7$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(popper);
            if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || placement === (0, $935c50c8659545b7$export$79ffe56a765070d2)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideY = (0, $935c50c8659545b7$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || placement === (0, $935c50c8659545b7$export$40e543e69a8b3fbb)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideX = (0, $935c50c8659545b7$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $063d2297888fea12$var$unsetSides);
    var _ref4 = roundOffsets === true ? $063d2297888fea12$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $063d2297888fea12$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $063d2297888fea12$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $063d2297888fea12$var$computeStyles,
    data: {}
};



var $fa02e10eb4995658$var$passive = {
    passive: true
};
function $fa02e10eb4995658$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fa02e10eb4995658$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $fa02e10eb4995658$var$effect,
    data: {}
};


var $d79ddf39683d3f91$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $d79ddf39683d3f91$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d79ddf39683d3f91$var$hash[matched];
    });
}



var $5887002dcefa0743$var$hash = {
    start: 'end',
    end: 'start'
};
function $5887002dcefa0743$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5887002dcefa0743$var$hash[matched];
    });
}








function $0acc17feb41c51bd$export$2e2bcd8739ae039(node) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $e951d80a0194865c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)).left + (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $7da9d5689cacb0a6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b49248e188a52b8b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $ab4ea6dd03061fae$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $9873d63ab8539814$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $c48b941fd834c962$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node) && (0, $9873d63ab8539814$export$2e2bcd8739ae039)(node)) return node;
    return $c48b941fd834c962$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(node));
}





function $295d0ca7e8ef250a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $c48b941fd834c962$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9873d63ab8539814$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($295d0ca7e8ef250a$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(target)));
}










function $1cd357ee33805adc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $93ee5964b4e9d426$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) ? (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $7da9d5689cacb0a6$export$2e2bcd8739ae039)(element, strategy)) : (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) ? $93ee5964b4e9d426$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $ab4ea6dd03061fae$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $93ee5964b4e9d426$var$getClippingParents(element) {
    var clippingParents = (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) ? (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) && (0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $93ee5964b4e9d426$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $93ee5964b4e9d426$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $93ee5964b4e9d426$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $4f7414566eeea71a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $935c50c8659545b7$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $935c50c8659545b7$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $935c50c8659545b7$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $935c50c8659545b7$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $935c50c8659545b7$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $935c50c8659545b7$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $70321b611e132ecc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $935c50c8659545b7$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $935c50c8659545b7$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? (0, $935c50c8659545b7$export$ca50aac9f3ba507f) : (0, $935c50c8659545b7$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $93ee5964b4e9d426$export$2e2bcd8739ae039)((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $1cd357ee33805adc$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $935c50c8659545b7$export$79ffe56a765070d2),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $935c50c8659545b7$export$1e95b668f3b82d),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $bec6b628c79c2a3d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $935c50c8659545b7$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $935c50c8659545b7$export$368f9a87e87fa4e1) : (0, $935c50c8659545b7$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $935c50c8659545b7$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $dabd09962ff7b702$var$getExpandedFallbackPlacements(placement) {
    if ((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(placement);
    return [
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $dabd09962ff7b702$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $dabd09962ff7b702$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860) ? (0, $bec6b628c79c2a3d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$b3571188c770cc5a);
        var isVertical = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $935c50c8659545b7$export$79ffe56a765070d2) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dabd09962ff7b702$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $dabd09962ff7b702$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $7d3d400f3b7c97f3$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7d3d400f3b7c97f3$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $935c50c8659545b7$export$1e95b668f3b82d),
        (0, $935c50c8659545b7$export$79ffe56a765070d2),
        (0, $935c50c8659545b7$export$40e543e69a8b3fbb),
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7d3d400f3b7c97f3$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7d3d400f3b7c97f3$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $7d3d400f3b7c97f3$var$hide
};




function $8d644778f0e020f0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8d644778f0e020f0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $935c50c8659545b7$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $8d644778f0e020f0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8d644778f0e020f0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8d644778f0e020f0$var$offset
};



function $ee48a1861d343976$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ee48a1861d343976$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ee48a1861d343976$var$popperOffsets,
    data: {}
};





function $e82c9e5baaa8e9af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $4804c92787f86449$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $e82c9e5baaa8e9af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4faf3481d1df2f95$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4804c92787f86449$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $4804c92787f86449$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $c829ab0279467772$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b71097fc0b0e5f5c$export$2e2bcd8739ae039(node) {
    if (node === (0, $2835f189066da699$export$2e2bcd8739ae039)(node) || !(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node)) return (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(node);
    else return (0, $c829ab0279467772$export$2e2bcd8739ae039)(node);
}








function $b01cf64433a5b37b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $b01cf64433a5b37b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent) && $b01cf64433a5b37b$var$isElementScaled(offsetParent);
    var documentElement = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9873d63ab8539814$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b71097fc0b0e5f5c$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e951d80a0194865c$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $455dca0e08f2a815$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $455dca0e08f2a815$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $455dca0e08f2a815$var$order(modifiers); // order based on phase
    return (0, $935c50c8659545b7$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $6d2b77c34ff005f5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $81912adbd60ec5c0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $1839837374f95732$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $1839837374f95732$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $1839837374f95732$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $1839837374f95732$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $1839837374f95732$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(reference) ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $455dca0e08f2a815$export$2e2bcd8739ae039)((0, $81912adbd60ec5c0$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$1839837374f95732$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $b01cf64433a5b37b$export$2e2bcd8739ae039)(reference, (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $ad01075005a54bff$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6d2b77c34ff005f5$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$1839837374f95732$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $1839837374f95732$export$8f7491d57c8f97a9 = /*#__PURE__*/ $1839837374f95732$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $98a9ef6d31ff03cd$export$d34966752335dd47 = [
    (0, $fa02e10eb4995658$export$2e2bcd8739ae039),
    (0, $ee48a1861d343976$export$2e2bcd8739ae039),
    (0, $063d2297888fea12$export$2e2bcd8739ae039),
    (0, $312913fa2edc14b2$export$2e2bcd8739ae039),
    (0, $8d644778f0e020f0$export$2e2bcd8739ae039),
    (0, $dabd09962ff7b702$export$2e2bcd8739ae039),
    (0, $4804c92787f86449$export$2e2bcd8739ae039),
    (0, $20e743289f291887$export$2e2bcd8739ae039),
    (0, $7d3d400f3b7c97f3$export$2e2bcd8739ae039)
];
var $98a9ef6d31ff03cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1839837374f95732$export$ed5e13716264f202)({
    defaultModifiers: $98a9ef6d31ff03cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $0468327f9101fb67$export$d34966752335dd47 = [
    (0, $fa02e10eb4995658$export$2e2bcd8739ae039),
    (0, $ee48a1861d343976$export$2e2bcd8739ae039),
    (0, $063d2297888fea12$export$2e2bcd8739ae039),
    (0, $312913fa2edc14b2$export$2e2bcd8739ae039)
];
var $0468327f9101fb67$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1839837374f95732$export$ed5e13716264f202)({
    defaultModifiers: $0468327f9101fb67$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($1e278783c7067372$exports, $935c50c8659545b7$exports);
$parcel$exportWildcard($1e278783c7067372$exports, $133f6f38ce92f501$exports);







/**
 * Constants
 */ const $36b842a56830a51f$var$NAME = 'dropdown';
const $36b842a56830a51f$var$DATA_KEY = 'bs.dropdown';
const $36b842a56830a51f$var$EVENT_KEY = `.${$36b842a56830a51f$var$DATA_KEY}`;
const $36b842a56830a51f$var$DATA_API_KEY = '.data-api';
const $36b842a56830a51f$var$ESCAPE_KEY = 'Escape';
const $36b842a56830a51f$var$TAB_KEY = 'Tab';
const $36b842a56830a51f$var$ARROW_UP_KEY = 'ArrowUp';
const $36b842a56830a51f$var$ARROW_DOWN_KEY = 'ArrowDown';
const $36b842a56830a51f$var$RIGHT_MOUSE_BUTTON = 2 // MouseEvent.button value for the secondary button, usually the right button
;
const $36b842a56830a51f$var$EVENT_HIDE = `hide${$36b842a56830a51f$var$EVENT_KEY}`;
const $36b842a56830a51f$var$EVENT_HIDDEN = `hidden${$36b842a56830a51f$var$EVENT_KEY}`;
const $36b842a56830a51f$var$EVENT_SHOW = `show${$36b842a56830a51f$var$EVENT_KEY}`;
const $36b842a56830a51f$var$EVENT_SHOWN = `shown${$36b842a56830a51f$var$EVENT_KEY}`;
const $36b842a56830a51f$var$EVENT_CLICK_DATA_API = `click${$36b842a56830a51f$var$EVENT_KEY}${$36b842a56830a51f$var$DATA_API_KEY}`;
const $36b842a56830a51f$var$EVENT_KEYDOWN_DATA_API = `keydown${$36b842a56830a51f$var$EVENT_KEY}${$36b842a56830a51f$var$DATA_API_KEY}`;
const $36b842a56830a51f$var$EVENT_KEYUP_DATA_API = `keyup${$36b842a56830a51f$var$EVENT_KEY}${$36b842a56830a51f$var$DATA_API_KEY}`;
const $36b842a56830a51f$var$CLASS_NAME_SHOW = 'show';
const $36b842a56830a51f$var$CLASS_NAME_DROPUP = 'dropup';
const $36b842a56830a51f$var$CLASS_NAME_DROPEND = 'dropend';
const $36b842a56830a51f$var$CLASS_NAME_DROPSTART = 'dropstart';
const $36b842a56830a51f$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $36b842a56830a51f$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $36b842a56830a51f$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $36b842a56830a51f$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$36b842a56830a51f$var$SELECTOR_DATA_TOGGLE}.${$36b842a56830a51f$var$CLASS_NAME_SHOW}`;
const $36b842a56830a51f$var$SELECTOR_MENU = '.dropdown-menu';
const $36b842a56830a51f$var$SELECTOR_NAVBAR = '.navbar';
const $36b842a56830a51f$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $36b842a56830a51f$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $36b842a56830a51f$var$PLACEMENT_TOP = (0, $624ac0747f128bc7$export$702d680b21cbd764)() ? 'top-end' : 'top-start';
const $36b842a56830a51f$var$PLACEMENT_TOPEND = (0, $624ac0747f128bc7$export$702d680b21cbd764)() ? 'top-start' : 'top-end';
const $36b842a56830a51f$var$PLACEMENT_BOTTOM = (0, $624ac0747f128bc7$export$702d680b21cbd764)() ? 'bottom-end' : 'bottom-start';
const $36b842a56830a51f$var$PLACEMENT_BOTTOMEND = (0, $624ac0747f128bc7$export$702d680b21cbd764)() ? 'bottom-start' : 'bottom-end';
const $36b842a56830a51f$var$PLACEMENT_RIGHT = (0, $624ac0747f128bc7$export$702d680b21cbd764)() ? 'left-start' : 'right-start';
const $36b842a56830a51f$var$PLACEMENT_LEFT = (0, $624ac0747f128bc7$export$702d680b21cbd764)() ? 'right-start' : 'left-start';
const $36b842a56830a51f$var$PLACEMENT_TOPCENTER = 'top';
const $36b842a56830a51f$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $36b842a56830a51f$var$Default = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $36b842a56830a51f$var$DefaultType = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $36b842a56830a51f$var$Dropdown extends (0, $380170e9fa23ab96$export$2e2bcd8739ae039) {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode // dropdown wrapper
        ;
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).next(this._element, $36b842a56830a51f$var$SELECTOR_MENU)[0] || (0, $56a58c95834dffd7$export$2e2bcd8739ae039).prev(this._element, $36b842a56830a51f$var$SELECTOR_MENU)[0] || (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($36b842a56830a51f$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $36b842a56830a51f$var$Default;
    }
    static get DefaultType() {
        return $36b842a56830a51f$var$DefaultType;
    }
    static get NAME() {
        return $36b842a56830a51f$var$NAME;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ((0, $624ac0747f128bc7$export$30e0dc115df457ed)(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $36b842a56830a51f$var$EVENT_SHOW, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($36b842a56830a51f$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))(0, $1c297f733361d974$export$2e2bcd8739ae039).on(element, 'mouseover', (0, $624ac0747f128bc7$export$8793edee2d425525));
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($36b842a56830a51f$var$CLASS_NAME_SHOW);
        this._element.classList.add($36b842a56830a51f$var$CLASS_NAME_SHOW);
        (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $36b842a56830a51f$var$EVENT_SHOWN, relatedTarget);
    }
    hide() {
        if ((0, $624ac0747f128bc7$export$30e0dc115df457ed)(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $36b842a56830a51f$var$EVENT_HIDE, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))(0, $1c297f733361d974$export$2e2bcd8739ae039).off(element, 'mouseover', (0, $624ac0747f128bc7$export$8793edee2d425525));
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($36b842a56830a51f$var$CLASS_NAME_SHOW);
        this._element.classList.remove($36b842a56830a51f$var$CLASS_NAME_SHOW);
        this._element.setAttribute('aria-expanded', 'false');
        (0, $61e4c97070b47d88$export$2e2bcd8739ae039).removeDataAttribute(this._menu, 'popper');
        (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $36b842a56830a51f$var$EVENT_HIDDEN, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !(0, $624ac0747f128bc7$export$45a5e7f76e0caa8d)(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$36b842a56830a51f$var$NAME.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $1e278783c7067372$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ((0, $624ac0747f128bc7$export$45a5e7f76e0caa8d)(this._config.reference)) referenceElement = (0, $624ac0747f128bc7$export$d16800b7e59a8051)(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $1e278783c7067372$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($36b842a56830a51f$var$CLASS_NAME_SHOW);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($36b842a56830a51f$var$CLASS_NAME_DROPEND)) return $36b842a56830a51f$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($36b842a56830a51f$var$CLASS_NAME_DROPSTART)) return $36b842a56830a51f$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($36b842a56830a51f$var$CLASS_NAME_DROPUP_CENTER)) return $36b842a56830a51f$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($36b842a56830a51f$var$CLASS_NAME_DROPDOWN_CENTER)) return $36b842a56830a51f$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($36b842a56830a51f$var$CLASS_NAME_DROPUP)) return isEnd ? $36b842a56830a51f$var$PLACEMENT_TOPEND : $36b842a56830a51f$var$PLACEMENT_TOP;
        return isEnd ? $36b842a56830a51f$var$PLACEMENT_BOTTOMEND : $36b842a56830a51f$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($36b842a56830a51f$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            (0, $61e4c97070b47d88$export$2e2bcd8739ae039).setDataAttribute(this._menu, 'popper', 'static') // TODO: v6 remove
            ;
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...(0, $624ac0747f128bc7$export$51396ec711da548b)(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find($36b842a56830a51f$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>(0, $624ac0747f128bc7$export$795910f5f15a9633)(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        (0, $624ac0747f128bc7$export$7bc25e2173fc3d1f)(items, target, key === $36b842a56830a51f$var$ARROW_DOWN_KEY, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $36b842a56830a51f$var$Dropdown.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $36b842a56830a51f$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $36b842a56830a51f$var$TAB_KEY) return;
        const openToggles = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find($36b842a56830a51f$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $36b842a56830a51f$var$Dropdown.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $36b842a56830a51f$var$TAB_KEY || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $36b842a56830a51f$var$ESCAPE_KEY;
        const isUpOrDownEvent = [
            $36b842a56830a51f$var$ARROW_UP_KEY,
            $36b842a56830a51f$var$ARROW_DOWN_KEY
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($36b842a56830a51f$var$SELECTOR_DATA_TOGGLE) ? this : (0, $56a58c95834dffd7$export$2e2bcd8739ae039).prev(this, $36b842a56830a51f$var$SELECTOR_DATA_TOGGLE)[0] || (0, $56a58c95834dffd7$export$2e2bcd8739ae039).next(this, $36b842a56830a51f$var$SELECTOR_DATA_TOGGLE)[0] || (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($36b842a56830a51f$var$SELECTOR_DATA_TOGGLE, event.delegateTarget.parentNode);
        const instance = $36b842a56830a51f$var$Dropdown.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ (0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $36b842a56830a51f$var$EVENT_KEYDOWN_DATA_API, $36b842a56830a51f$var$SELECTOR_DATA_TOGGLE, $36b842a56830a51f$var$Dropdown.dataApiKeydownHandler);
(0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $36b842a56830a51f$var$EVENT_KEYDOWN_DATA_API, $36b842a56830a51f$var$SELECTOR_MENU, $36b842a56830a51f$var$Dropdown.dataApiKeydownHandler);
(0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $36b842a56830a51f$var$EVENT_CLICK_DATA_API, $36b842a56830a51f$var$Dropdown.clearMenus);
(0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $36b842a56830a51f$var$EVENT_KEYUP_DATA_API, $36b842a56830a51f$var$Dropdown.clearMenus);
(0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $36b842a56830a51f$var$EVENT_CLICK_DATA_API, $36b842a56830a51f$var$SELECTOR_DATA_TOGGLE, function(event) {
    event.preventDefault();
    $36b842a56830a51f$var$Dropdown.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ (0, $624ac0747f128bc7$export$6be86de4be20ff32)($36b842a56830a51f$var$Dropdown);
var $36b842a56830a51f$export$2e2bcd8739ae039 = $36b842a56830a51f$var$Dropdown;


/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 


/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 


/**
 * Constants
 */ const $bf7f248d3696c78e$var$NAME = 'backdrop';
const $bf7f248d3696c78e$var$CLASS_NAME_FADE = 'fade';
const $bf7f248d3696c78e$var$CLASS_NAME_SHOW = 'show';
const $bf7f248d3696c78e$var$EVENT_MOUSEDOWN = `mousedown.bs.${$bf7f248d3696c78e$var$NAME}`;
const $bf7f248d3696c78e$var$Default = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $bf7f248d3696c78e$var$DefaultType = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $bf7f248d3696c78e$var$Backdrop extends (0, $7beb0d0c06e1a235$export$2e2bcd8739ae039) {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $bf7f248d3696c78e$var$Default;
    }
    static get DefaultType() {
        return $bf7f248d3696c78e$var$DefaultType;
    }
    static get NAME() {
        return $bf7f248d3696c78e$var$NAME;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            (0, $624ac0747f128bc7$export$51396ec711da548b)(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) (0, $624ac0747f128bc7$export$b7a864e1eaef9de5)(element);
        element.classList.add($bf7f248d3696c78e$var$CLASS_NAME_SHOW);
        this._emulateAnimation(()=>{
            (0, $624ac0747f128bc7$export$51396ec711da548b)(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            (0, $624ac0747f128bc7$export$51396ec711da548b)(callback);
            return;
        }
        this._getElement().classList.remove($bf7f248d3696c78e$var$CLASS_NAME_SHOW);
        this._emulateAnimation(()=>{
            this.dispose();
            (0, $624ac0747f128bc7$export$51396ec711da548b)(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        (0, $1c297f733361d974$export$2e2bcd8739ae039).off(this._element, $bf7f248d3696c78e$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($bf7f248d3696c78e$var$CLASS_NAME_FADE);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = (0, $624ac0747f128bc7$export$d16800b7e59a8051)(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(element, $bf7f248d3696c78e$var$EVENT_MOUSEDOWN, ()=>{
            (0, $624ac0747f128bc7$export$51396ec711da548b)(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        (0, $624ac0747f128bc7$export$d6cd5457cf4106ef)(callback, this._getElement(), this._config.isAnimated);
    }
}
var $bf7f248d3696c78e$export$2e2bcd8739ae039 = $bf7f248d3696c78e$var$Backdrop;


/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 


const $f4665fe10f4cce58$export$a6d6a0122b3f26ee = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    (0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ((0, $624ac0747f128bc7$export$30e0dc115df457ed)(this)) return;
        const target = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};


/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 


/**
 * Constants
 */ const $a4e4747603202ebf$var$NAME = 'focustrap';
const $a4e4747603202ebf$var$DATA_KEY = 'bs.focustrap';
const $a4e4747603202ebf$var$EVENT_KEY = `.${$a4e4747603202ebf$var$DATA_KEY}`;
const $a4e4747603202ebf$var$EVENT_FOCUSIN = `focusin${$a4e4747603202ebf$var$EVENT_KEY}`;
const $a4e4747603202ebf$var$EVENT_KEYDOWN_TAB = `keydown.tab${$a4e4747603202ebf$var$EVENT_KEY}`;
const $a4e4747603202ebf$var$TAB_KEY = 'Tab';
const $a4e4747603202ebf$var$TAB_NAV_FORWARD = 'forward';
const $a4e4747603202ebf$var$TAB_NAV_BACKWARD = 'backward';
const $a4e4747603202ebf$var$Default = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $a4e4747603202ebf$var$DefaultType = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $a4e4747603202ebf$var$FocusTrap extends (0, $7beb0d0c06e1a235$export$2e2bcd8739ae039) {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $a4e4747603202ebf$var$Default;
    }
    static get DefaultType() {
        return $a4e4747603202ebf$var$DefaultType;
    }
    static get NAME() {
        return $a4e4747603202ebf$var$NAME;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        (0, $1c297f733361d974$export$2e2bcd8739ae039).off(document, $a4e4747603202ebf$var$EVENT_KEY) // guard against infinite focus loop
        ;
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $a4e4747603202ebf$var$EVENT_FOCUSIN, (event)=>this._handleFocusin(event));
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $a4e4747603202ebf$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        (0, $1c297f733361d974$export$2e2bcd8739ae039).off(document, $a4e4747603202ebf$var$EVENT_KEY);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $a4e4747603202ebf$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $a4e4747603202ebf$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $a4e4747603202ebf$var$TAB_NAV_BACKWARD : $a4e4747603202ebf$var$TAB_NAV_FORWARD;
    }
}
var $a4e4747603202ebf$export$2e2bcd8739ae039 = $a4e4747603202ebf$var$FocusTrap;



/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 


/**
 * Constants
 */ const $6593efd307f387da$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $6593efd307f387da$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $6593efd307f387da$var$PROPERTY_PADDING = 'padding-right';
const $6593efd307f387da$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $6593efd307f387da$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $6593efd307f387da$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($6593efd307f387da$var$SELECTOR_FIXED_CONTENT, $6593efd307f387da$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($6593efd307f387da$var$SELECTOR_STICKY_CONTENT, $6593efd307f387da$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $6593efd307f387da$var$PROPERTY_PADDING);
        this._resetElementAttributes($6593efd307f387da$var$SELECTOR_FIXED_CONTENT, $6593efd307f387da$var$PROPERTY_PADDING);
        this._resetElementAttributes($6593efd307f387da$var$SELECTOR_STICKY_CONTENT, $6593efd307f387da$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) (0, $61e4c97070b47d88$export$2e2bcd8739ae039).setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = (0, $61e4c97070b47d88$export$2e2bcd8739ae039).getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            (0, $61e4c97070b47d88$export$2e2bcd8739ae039).removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ((0, $624ac0747f128bc7$export$45a5e7f76e0caa8d)(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find(selector, this._element))callBack(sel);
    }
}
var $6593efd307f387da$export$2e2bcd8739ae039 = $6593efd307f387da$var$ScrollBarHelper;


/**
 * Constants
 */ const $8a7e64f151a1182a$var$NAME = 'modal';
const $8a7e64f151a1182a$var$DATA_KEY = 'bs.modal';
const $8a7e64f151a1182a$var$EVENT_KEY = `.${$8a7e64f151a1182a$var$DATA_KEY}`;
const $8a7e64f151a1182a$var$DATA_API_KEY = '.data-api';
const $8a7e64f151a1182a$var$ESCAPE_KEY = 'Escape';
const $8a7e64f151a1182a$var$EVENT_HIDE = `hide${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_HIDE_PREVENTED = `hidePrevented${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_HIDDEN = `hidden${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_SHOW = `show${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_SHOWN = `shown${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_RESIZE = `resize${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_CLICK_DISMISS = `click.dismiss${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_CLICK_DATA_API = `click${$8a7e64f151a1182a$var$EVENT_KEY}${$8a7e64f151a1182a$var$DATA_API_KEY}`;
const $8a7e64f151a1182a$var$CLASS_NAME_OPEN = 'modal-open';
const $8a7e64f151a1182a$var$CLASS_NAME_FADE = 'fade';
const $8a7e64f151a1182a$var$CLASS_NAME_SHOW = 'show';
const $8a7e64f151a1182a$var$CLASS_NAME_STATIC = 'modal-static';
const $8a7e64f151a1182a$var$OPEN_SELECTOR = '.modal.show';
const $8a7e64f151a1182a$var$SELECTOR_DIALOG = '.modal-dialog';
const $8a7e64f151a1182a$var$SELECTOR_MODAL_BODY = '.modal-body';
const $8a7e64f151a1182a$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="modal"]';
const $8a7e64f151a1182a$var$Default = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $8a7e64f151a1182a$var$DefaultType = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $8a7e64f151a1182a$var$Modal extends (0, $380170e9fa23ab96$export$2e2bcd8739ae039) {
    constructor(element, config){
        super(element, config);
        this._dialog = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($8a7e64f151a1182a$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new (0, $6593efd307f387da$export$2e2bcd8739ae039)();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $8a7e64f151a1182a$var$Default;
    }
    static get DefaultType() {
        return $8a7e64f151a1182a$var$DefaultType;
    }
    static get NAME() {
        return $8a7e64f151a1182a$var$NAME;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $8a7e64f151a1182a$var$EVENT_SHOW, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($8a7e64f151a1182a$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $8a7e64f151a1182a$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($8a7e64f151a1182a$var$CLASS_NAME_SHOW);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        (0, $1c297f733361d974$export$2e2bcd8739ae039).off(window, $8a7e64f151a1182a$var$EVENT_KEY);
        (0, $1c297f733361d974$export$2e2bcd8739ae039).off(this._dialog, $8a7e64f151a1182a$var$EVENT_KEY);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new (0, $bf7f248d3696c78e$export$2e2bcd8739ae039)({
            isVisible: Boolean(this._config.backdrop),
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new (0, $a4e4747603202ebf$export$2e2bcd8739ae039)({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($8a7e64f151a1182a$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        (0, $624ac0747f128bc7$export$b7a864e1eaef9de5)(this._element);
        this._element.classList.add($8a7e64f151a1182a$var$CLASS_NAME_SHOW);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $8a7e64f151a1182a$var$EVENT_SHOWN, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $8a7e64f151a1182a$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $8a7e64f151a1182a$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(window, $8a7e64f151a1182a$var$EVENT_RESIZE, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $8a7e64f151a1182a$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            (0, $1c297f733361d974$export$2e2bcd8739ae039).one(this._element, $8a7e64f151a1182a$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($8a7e64f151a1182a$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $8a7e64f151a1182a$var$EVENT_HIDDEN);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($8a7e64f151a1182a$var$CLASS_NAME_FADE);
    }
    _triggerBackdropTransition() {
        const hideEvent = (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $8a7e64f151a1182a$var$EVENT_HIDE_PREVENTED);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($8a7e64f151a1182a$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($8a7e64f151a1182a$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($8a7e64f151a1182a$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = (0, $624ac0747f128bc7$export$702d680b21cbd764)() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = (0, $624ac0747f128bc7$export$702d680b21cbd764)() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $8a7e64f151a1182a$var$Modal.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ (0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $8a7e64f151a1182a$var$EVENT_CLICK_DATA_API, $8a7e64f151a1182a$var$SELECTOR_DATA_TOGGLE, function(event) {
    const target = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    (0, $1c297f733361d974$export$2e2bcd8739ae039).one(target, $8a7e64f151a1182a$var$EVENT_SHOW, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        (0, $1c297f733361d974$export$2e2bcd8739ae039).one(target, $8a7e64f151a1182a$var$EVENT_HIDDEN, ()=>{
            if ((0, $624ac0747f128bc7$export$795910f5f15a9633)(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($8a7e64f151a1182a$var$OPEN_SELECTOR);
    if (alreadyOpen) $8a7e64f151a1182a$var$Modal.getInstance(alreadyOpen).hide();
    const data = $8a7e64f151a1182a$var$Modal.getOrCreateInstance(target);
    data.toggle(this);
});
(0, $f4665fe10f4cce58$export$a6d6a0122b3f26ee)($8a7e64f151a1182a$var$Modal);
/**
 * jQuery
 */ (0, $624ac0747f128bc7$export$6be86de4be20ff32)($8a7e64f151a1182a$var$Modal);
var $8a7e64f151a1182a$export$2e2bcd8739ae039 = $8a7e64f151a1182a$var$Modal;






const $3fff2643c3ded715$var$NAME = 'tagfilter';
const $3fff2643c3ded715$var$DATA_KEY = 'bs.tagfilter';
const $3fff2643c3ded715$var$EVENT_KEY = `.${$3fff2643c3ded715$var$DATA_KEY}`;
const $3fff2643c3ded715$var$DATA_API_KEY = '.data-api';
const $3fff2643c3ded715$var$EVENT_LOAD_DATA_API = `load${$3fff2643c3ded715$var$EVENT_KEY}${$3fff2643c3ded715$var$DATA_API_KEY}`;
const $3fff2643c3ded715$var$EVENT_FOCUS_DATA_API = `focus${$3fff2643c3ded715$var$EVENT_KEY}${$3fff2643c3ded715$var$DATA_API_KEY}`;
const $3fff2643c3ded715$var$EVENT_CLICK_DATA_API = `click${$3fff2643c3ded715$var$EVENT_KEY}${$3fff2643c3ded715$var$DATA_API_KEY}`;
const $3fff2643c3ded715$var$EVENT_KEYUP = `keyup${$3fff2643c3ded715$var$EVENT_KEY}`;
const $3fff2643c3ded715$var$EVENT_CHANGE = `change${$3fff2643c3ded715$var$EVENT_KEY}`;
const $3fff2643c3ded715$var$SELECTOR_DATA_TOGGLE = '[data-tag-filter]';
const $3fff2643c3ded715$var$SELECTOR_INPUT = ".tag-filter--input";
const $3fff2643c3ded715$var$SELECTOR_ACTIVE_TAGS = ".tag-filter--active";
const $3fff2643c3ded715$var$SELECTOR_INACTIVE_TAGS = ".tag-filter--inactive";
class $3fff2643c3ded715$var$TagFilter extends (0, $380170e9fa23ab96$export$2e2bcd8739ae039) {
    constructor(element, config){
        super(element, config);
        this._inputContainer = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($3fff2643c3ded715$var$SELECTOR_INPUT, element);
        this._activeContainer = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($3fff2643c3ded715$var$SELECTOR_ACTIVE_TAGS, element);
        this._inactiveContainer = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($3fff2643c3ded715$var$SELECTOR_INACTIVE_TAGS, element);
        this._target = `data-tag-filter-${element.getAttribute('data-tag-filter')}`;
        this._tags = this._generateTags();
        this._activeTags = [];
        this._inactiveTags = [
            ...this._tags
        ];
        const input = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne("input", element);
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(input, $3fff2643c3ded715$var$EVENT_FOCUS_DATA_API, ()=>{
            element.classList.add("focused");
        });
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(element, $3fff2643c3ded715$var$EVENT_CLICK_DATA_API, (event)=>{
            event.stopPropagation();
        });
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $3fff2643c3ded715$var$EVENT_CLICK_DATA_API, ()=>element.classList.remove("focused"));
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(input, $3fff2643c3ded715$var$EVENT_KEYUP, (event)=>{
            this._filterInactiveTags(input.value);
        });
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(input, $3fff2643c3ded715$var$EVENT_CHANGE, ()=>{
            this._filterInactiveTags(input.value);
        });
        this._generateTagButtons();
        this._filterTargets();
    }
    // Getters
    static get NAME() {
        return $3fff2643c3ded715$var$NAME;
    }
    // Public 
    // Private
    _generateTags() {
        const tags = [];
        const elements = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find(`[${this._target}]`);
        for (const element of elements){
            const values = JSON.parse(element.getAttribute(this._target));
            for (const value of values)tags.push(value);
        }
        return tags.filter((value, index, self)=>{
            return self.indexOf(value) === index;
        }).sort();
    }
    _generateTagButtons() {
        for (const tag of this._activeTags){
            const button = document.createElement("button");
            button.innerText = tag;
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(button, $3fff2643c3ded715$var$EVENT_CLICK_DATA_API, (event)=>this._toggleTag(event, tag));
            this._activeContainer.appendChild(button);
        }
        for (const tag of this._inactiveTags){
            const button = document.createElement("button");
            button.innerText = tag;
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(button, $3fff2643c3ded715$var$EVENT_CLICK_DATA_API, (event)=>this._toggleTag(event, tag));
            this._inactiveContainer.appendChild(button);
        }
    }
    _toggleTag(event, tag) {
        event.preventDefault();
        if (this._activeTags.indexOf(tag) >= 0) {
            this._activeTags = this._activeTags.filter((item)=>item !== tag);
            this._inactiveTags.push(tag);
            this._activeContainer.removeChild(event.delegateTarget);
            this._inactiveContainer.appendChild(event.delegateTarget);
        } else {
            this._inactiveTags = this._inactiveTags.filter((item)=>item !== tag);
            this._activeTags.push(tag);
            this._inactiveContainer.removeChild(event.delegateTarget);
            this._activeContainer.appendChild(event.delegateTarget);
        }
        this._filterTargets();
    }
    _filterTargets() {
        this._hideEmptyInactiveSection();
        const elements = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find(`[${this._target}]`);
        if (this._activeTags.length <= 0) {
            this._element.classList.remove("has-active");
            for (const element of elements)element.setAttribute(`${this._target}-hide`, false);
            return;
        }
        this._element.classList.add("has-active");
        for (const element of elements){
            const values = JSON.parse(element.getAttribute(this._target));
            if (this._activeTags.filter((x)=>values.includes(x)).length <= 0) element.setAttribute(`${this._target}-hide`, true);
            else element.setAttribute(`${this._target}-hide`, false);
        }
    }
    _filterInactiveTags(tag) {
        var count = 0;
        for (const button of this._inactiveContainer.children){
            if (tag.length <= 0) {
                button.classList.remove("d-none");
                continue;
            }
            if (button.innerText.toLowerCase().startsWith(tag.toLowerCase())) button.classList.remove("d-none");
            else {
                button.classList.add("d-none");
                count++;
            }
        }
        this._hideEmptyInactiveSection();
    }
    _hideEmptyInactiveSection() {
        for (const button of this._inactiveContainer.children)if (!button.classList.contains("d-none")) {
            this._element.classList.add("has-inactive");
            return;
        }
        this._element.classList.remove("has-inactive");
        this._element.classList.remove("focused");
    }
}
/**
 * Data API implementation
 */ (0, $1c297f733361d974$export$2e2bcd8739ae039).on(window, $3fff2643c3ded715$var$EVENT_LOAD_DATA_API, ()=>{
    const tagFilters = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find($3fff2643c3ded715$var$SELECTOR_DATA_TOGGLE);
    for (const tagFilter of tagFilters)$3fff2643c3ded715$var$TagFilter.getOrCreateInstance(tagFilter);
});
(0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $3fff2643c3ded715$var$EVENT_CLICK_DATA_API, ()=>{});
/**
 * jQuery
 */ (0, $624ac0747f128bc7$export$6be86de4be20ff32)($3fff2643c3ded715$var$TagFilter);
var $3fff2643c3ded715$export$2e2bcd8739ae039 = $3fff2643c3ded715$var$TagFilter;






const $9b506c85ba5b6f1a$var$NAME = 'imageslider';
const $9b506c85ba5b6f1a$var$DATA_KEY = 'bs.imageslider';
const $9b506c85ba5b6f1a$var$EVENT_KEY = `.${$9b506c85ba5b6f1a$var$DATA_KEY}`;
const $9b506c85ba5b6f1a$var$DATA_API_KEY = '.data-api';
const $9b506c85ba5b6f1a$var$EVENT_LOAD_DATA_API = `load${$9b506c85ba5b6f1a$var$EVENT_KEY}${$9b506c85ba5b6f1a$var$DATA_API_KEY}`;
const $9b506c85ba5b6f1a$var$SELECTOR_DATA_TOGGLE = '[data-image-slider]';
class $9b506c85ba5b6f1a$var$ImageSlider extends (0, $380170e9fa23ab96$export$2e2bcd8739ae039) {
    constructor(element, config){
        super(element, config);
        const input = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne(".slider", element);
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(input, 'input', (event)=>{
            element.style.setProperty('--position', `${event.target.value}%`);
        });
    }
    // Getters
    static get NAME() {
        return $9b506c85ba5b6f1a$var$NAME;
    }
}
/**
 * Data API implementation
 */ (0, $1c297f733361d974$export$2e2bcd8739ae039).on(window, $9b506c85ba5b6f1a$var$EVENT_LOAD_DATA_API, ()=>{
    const imageSliders = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find($9b506c85ba5b6f1a$var$SELECTOR_DATA_TOGGLE);
    for (const imageSlider of imageSliders)$9b506c85ba5b6f1a$var$ImageSlider.getOrCreateInstance(imageSlider);
});
/**
 * jQuery
 */ (0, $624ac0747f128bc7$export$6be86de4be20ff32)($9b506c85ba5b6f1a$var$ImageSlider);
var $9b506c85ba5b6f1a$export$2e2bcd8739ae039 = $9b506c85ba5b6f1a$var$ImageSlider;


function $a128d59f9b829b8a$var$preloadSlideAndNeighbors(carouselEl, index) {
    if (!carouselEl) return;
    const items = carouselEl.querySelectorAll('.carousel-item');
    const total = items.length;
    if (total === 0) return;
    const indices = [
        index,
        (index - 1 + total) % total,
        (index + 1) % total
    ];
    for (const idx of indices){
        const img = items[idx]?.querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
    }
}
document.addEventListener('show.bs.modal', (e)=>{
    const modal = e.target;
    if (!modal || !modal.classList.contains('galleryElement--modal')) return;
    const carouselEl = modal.querySelector('.carousel');
    if (!carouselEl) return;
    const items = Array.from(carouselEl.querySelectorAll('.carousel-item'));
    const activeIdx = Math.max(0, items.findIndex((el)=>el.classList.contains('active')));
    $a128d59f9b829b8a$var$preloadSlideAndNeighbors(carouselEl, activeIdx);
});
document.addEventListener('slide.bs.carousel', (e)=>{
    const carouselEl = e.target;
    if (!carouselEl || !carouselEl.closest('.galleryElement--modal')) return;
    if (typeof e.to === 'number') $a128d59f9b829b8a$var$preloadSlideAndNeighbors(carouselEl, e.to);
});
document.addEventListener('keydown', (event)=>{
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    const openModal = document.querySelector('.galleryElement--modal.show');
    if (!openModal) return;
    const carouselEl = openModal.querySelector('.carousel');
    if (!carouselEl) return;
    const carousel = (0, $dbacec9b9313e733$export$2e2bcd8739ae039).getOrCreateInstance(carouselEl);
    if (event.key === 'ArrowLeft') {
        event.preventDefault();
        carousel.prev();
    } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        carousel.next();
    }
});
var $a128d59f9b829b8a$export$2e2bcd8739ae039 = {
    Carousel: $dbacec9b9313e733$export$2e2bcd8739ae039,
    Collapse: $d66ebc93fbedd854$export$2e2bcd8739ae039,
    Dropdown: $36b842a56830a51f$export$2e2bcd8739ae039,
    Modal: $8a7e64f151a1182a$export$2e2bcd8739ae039,
    Filtering: $3fff2643c3ded715$export$2e2bcd8739ae039,
    ImageSlider: $9b506c85ba5b6f1a$export$2e2bcd8739ae039
};
var $a128d59f9b829b8a$var$cssRule1 = "color: rgb(1, 103, 150);line-height: 1;font-size: 20px;font-weight: bold;";
var $a128d59f9b829b8a$var$cssRule2 = "color: rgb(1, 103, 150);line-height: 1;font-size: 36px;font-weight: bold;";
setTimeout(console.log.bind(console, "Built by"), 0);
setTimeout(console.log.bind(console, "%ccoastal\n%cC#DE", $a128d59f9b829b8a$var$cssRule1, $a128d59f9b829b8a$var$cssRule2), 0);
setTimeout(console.log.bind(console, "Visit: https://coastal-code.com/"), 0);
setTimeout(console.log.bind(console, "Email: info@coastal-code.com"), 0);

})();
//# sourceMappingURL=index.js.map
